import { useApi } from "@/composition/useApi.js";

export default {
  state: () => ({
    integrationData: {}, // данные интеграции
    errorTextRequest: null, // тексты об ошибках
    errorTextRequestAsync: null, // тексты об ошибках синхронизации
    successTextRequestAsync: null, // тексты об успешной синхронизации
    integrationsModalIsShow: false, // открыта ли модалка
    integrationsInfoModalIsShow: false, // открыта ли информационная модалка
    integrationsInfoModalData: null, // данные для информационной модалки
    allIntegrations: [], // все интеграции
    setSpinerIntegrations: true, // спиннер
    setSpinerIntegrationsModal: true, // спиннер для модального окна
    setSpinerSync: false, // спиннер для синхронизации
    editingIntegration: null, // редактируемая интеграция
    fortCompany: [], // список компаний
  }),
  mutations: {
    setIntegrationDetails(state, integration) {
      if (!integration) {
        state.integrationData = {};
        return;
      }
      const { name, status, lastSyncAt, syncStatus } = integration;
      state.integrationData = { name, status, lastSyncAt, syncStatus };
    },
    setIntegrationsList(state, payload) {
      state.allIntegrations = payload;
    },
    setIntegrationsModalVisibility(state, bool) {
      state.integrationsModalIsShow = bool;
    },
    setIntegrationsInfoModalVisibility(state, bool) {
      state.integrationsInfoModalIsShow = bool;
    },
    setIntegrationsInfoModalData(state, data) {
      state.integrationsInfoModalData = data;
    },
    setSpinerIntegrations(state, bool) {
      state.setSpinerIntegrations = bool;
    },
    setSpinerIntegrationsSync(state, bool) {
      state.setSpinerSync = bool;
    },
    setSpinerIntegrationsModal(state, bool) {
      state.setSpinerIntegrationsModal = bool;
    },
    setEditingIntegration(state, payload) {
      state.editingIntegration = payload;
    },
    setIntegrationErrorTextRequest(state, text) {
      state.errorTextRequest = text;
      setTimeout(() => (state.errorTextRequest = null), 5000);
    },
    setIntegrationErrorTextRequestAsync(state, text) {
      state.errorTextRequestAsync = text;
      setTimeout(() => (state.errorTextRequestAsync = null), 5000);
    },
    setIntegrationSuccessTextRequestAsync(state, text) {
      state.successTextRequestAsync = text;
      setTimeout(() => (state.successTextRequestAsync = null), 5000);
    },
    setFortCompanyIds(state, payload) {
      state.fortCompany = payload;
    },
  },
  actions: {
    getIntegrationsList({ commit }) {
      const { api } = useApi();
      commit("setSpinerIntegrations", true);
      return api
        .get(`/fort-integration`)
        .then(r => {
          if (r.status == 200) {
            commit("setIntegrationsList", r.data);
            commit("setSpinerIntegrations", false);
          }
          return r.status;
        })
        .catch(err => {
          commit("setSpinerIntegrations", false);
          commit("setIntegrationErrorTextRequest", err.message);
        });
    },
    createIntegration({ commit, dispatch }, data) {
      const { api } = useApi();
      return api
        .post(`/fort-integration`, data)
        .then(r => {
          dispatch("getIntegrationsList");
          commit("setIntegrationsModalVisibility", false);
          return r.status;
        })
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setIntegrationErrorTextRequest",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        });
    },
    updateIntegration({ commit, dispatch }, data) {
      const { api } = useApi();
      return api
        .put(`/fort-integration/${data.id}`, data.body)
        .then(() => {
          dispatch("getIntegrationsList");
          commit("setIntegrationsModalVisibility", false);
        })
        .catch(r => {
          if (r.response.data.message)
            commit(
              "setIntegrationErrorTextRequest",
              Array.isArray(r.response.data.message)
                ? r.response.data.message.join(", ")
                : r.response.data.message,
            );
        });
    },
    removeIntegration({ dispatch }, id) {
      const { api } = useApi();
      return api.delete(`/fort-integration/${id}`).then(r => {
        dispatch("getIntegrationsList");
        return r.status;
      });
    },
    getFortCompanyIds({ commit }, { login, password, url }) {
      const { api } = useApi();
      commit("setSpinerIntegrationsModal", true);
      return api
        .post(`/fort-integration/companies`, { login, password, url })
        .then(r => {
          if (r.status == 201) {
            commit("setFortCompanyIds", r.data);
            commit("setSpinerIntegrationsModal", false);
          }
          return r.status;
        })
        .catch(err => {
          commit("setIntegrationErrorTextRequest", err.message);
          commit("setSpinerIntegrationsModal", false);
        });
    },
    syncIntegration({ commit }, { id, name, status, lastSyncAt }) {
      const { api } = useApi();
      commit("setIntegrationDetails", {
        name,
        status,
        lastSyncAt,
        syncStatus: "синхронизации",
      });
      commit("setSpinerIntegrationsSync", true);
      return api
        .post(`/fort-integration/${id}/sync`)
        .then(r => {
          commit("setSpinerIntegrationsSync", false);
          commit(
            "setIntegrationSuccessTextRequestAsync",
            "Синхронизация прошла успешно!",
          );
          return r.status;
        })
        .catch(err => {
          commit("setSpinerIntegrationsSync", false);
          commit(
            "setIntegrationErrorTextRequestAsync",
            "ошибка синхронизации!",
          );
          commit("setIntegrationsInfoModalData", err.response.data.errors);
          commit("setIntegrationsInfoModalVisibility", true);
        });
    },
    fetchSyncErrors({ commit }, { id, name, status, lastSyncAt }) {
      const { api } = useApi();
      commit("setIntegrationDetails", {
        name,
        status,
        lastSyncAt,
        syncStatus: "интеграции",
      });
      return api
        .get(`/fort-integration/${id}/sync-errors`)
        .then(r => {
          commit("setIntegrationsInfoModalData", r.data);
          commit("setIntegrationsInfoModalVisibility", true);
        })
        .catch(() => {
          commit(
            "setIntegrationErrorTextRequestAsync",
            "ошибка получения данных синхронизации!",
          );
        });
    },
  },
};
